/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 1/25/2019.
 */

import React from 'react'
import {injectIntl} from 'react-intl';
import {FAULT_COLORS, FAULT_STATES} from '../faults/common/FaultsConst'
import { PieChart, Pie, Cell, Tooltip, Sector } from 'recharts';

const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload || !payload.length) {
        return null;
    }

    const item = payload[0];

    const dotColor = item.fill || item.color || (item.payload && item.payload.fill) || '#ff2d4d';

    return (
        <div className="chart-tooltip-box">
            <span className="chart-tooltip-dot" style={{ backgroundColor: dotColor }} />
            <span className="chart-tooltip-text">
                {item.name}: {Number(item.value).toFixed(2)}
            </span>
        </div>
    );
};

const renderActiveShape = (props) => {
    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props;
    return (
        <g>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={outerRadius - 1}
                outerRadius={outerRadius + 10}
                startAngle={0}
                endAngle={360}
                fill={fill}
                fillOpacity={0.25}
            />
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
                stroke="#ffffff"
                strokeWidth={1}
            />
        </g>
    );
};

class FleetChart extends React.Component {

    constructor(props) {
        super(props)
        this.state = { activeIndex: null, animKey: 0 }
    }

    componentDidMount() {
        this.setState({ animKey: Date.now() })
    }

    onPieEnter = (_, index) => {
        this.setState({ activeIndex: index })
    }

    onPieLeave = () => {
        this.setState({ activeIndex: null })
    }

    render() {
        const {intl, fleet} = this.props

        let assetsWithFaults = 0
        let assetsWithAlerts = 0
        let hasAlerts = 0;
        let hasFaults = 0;
        fleet.assetsFaultStatesCount.forEach(function(asset) {
                for (const i in Object.getOwnPropertyNames(asset.faultStatesCount)) {
                    if ((Object.getOwnPropertyNames(asset.faultStatesCount)[i] !== 'CLOSED_RESOLVED') &&
                        (Object.getOwnPropertyNames(asset.faultStatesCount)[i] !== 'CLOSED_DUE_TO_LDI_IMPORT') &&
                        (Object.getOwnPropertyNames(asset.faultStatesCount)[i] !== FAULT_STATES.CLOSED_DUE_TO_INACTIVITY)) {
                        if (Object.getOwnPropertyNames(asset.faultStatesCount)[i] !== 'NEW_ALERT') {
                            assetsWithFaults += 1;
                            hasFaults = 1;
                            break;
                        }
                        hasAlerts = 1;
                    }
                }
                if ((hasAlerts === 1) && (hasFaults === 0)) {
                    assetsWithAlerts += 1;
                    hasAlerts = 0;
                } else {
                    hasAlerts = 0;
                    hasFaults = 0;
                }
            }
        )

        const data = []
        const colors = []
        let hasToolTip = true
        if (fleet.assetCount <= 0) {
            data.push({
                name: intl.formatMessage({id: 'fleet.attr.assetsNoFaultCount'}),
                value: 1,
            })
            hasToolTip = false
            colors.push('#DEDEDE')
        } else {
            if (fleet.assetCount - assetsWithFaults - assetsWithAlerts > 0) {
                if (fleet.assetCount - assetsWithFaults - assetsWithAlerts === 1) {
                    data.push({
                        name: intl.formatMessage({id: 'fleet.attr.assetsNoFaultCount.one'}),
                        value: fleet.assetCount - assetsWithFaults,
                    })
                } else {
                    data.push({
                        name: intl.formatMessage({id: 'fleet.attr.assetsNoFaultCount'}),
                        value: fleet.assetCount - assetsWithFaults,
                    })
                }
                colors.push(FAULT_COLORS.CLOSED_RESOLVED)
            }
            if (assetsWithFaults > 0) {
                if (assetsWithFaults === 1) {
                    data.push({
                        name: intl.formatMessage({id: 'fleet.attr.assetsWithFaultCount.one'}),
                        value: assetsWithFaults,
                    })
                } else {
                    data.push({
                        name: intl.formatMessage({id: 'fleet.attr.assetsWithFaultCount'}),
                        value: assetsWithFaults,
                    })
                }
                colors.push(FAULT_COLORS.NEW)
            }
            if (assetsWithAlerts > 0) {
                if (assetsWithAlerts === 1) {
                    data.push({
                        name: intl.formatMessage({id: 'fleet.attr.assetsWithAlertCount.one'}),
                        value: assetsWithAlerts,
                    })
                } else {
                    data.push({
                        name: intl.formatMessage({id: 'fleet.attr.assetsWithAlertCount'}),
                        value: assetsWithAlerts,
                    })
                }
                colors.push(FAULT_COLORS.NEW_ALERT)
            }
        }

        const size = this.props.height || 200

        const donut = (
            <div className="chart-pie-container" style={{ width: size, height: size }}>
                <PieChart width={size} height={size}>
                    <Pie key={this.state.animKey} data={data} dataKey="value" innerRadius="62.475%" outerRadius="73.5%" startAngle={90} endAngle={-270}
                        animationBegin={0}
                        animationDuration={900}
                        activeIndex={this.state.activeIndex}
                        activeShape={renderActiveShape}
                        onMouseEnter={this.onPieEnter}
                        onMouseLeave={this.onPieLeave}
                    >
                        {data.map((entry, index) => (
                            <Cell key={index} fill={colors[index]} />
                        ))}
                    </Pie>
                    {hasToolTip && <Tooltip
                        content={<CustomTooltip />}
                        wrapperClassName="chart-tooltip"
                        cursor={false}
                    />}
                </PieChart>
                <div className="center-block">
                    <div className="title">{fleet.assetCount === 0 ? '0' : fleet.assetCount}</div>
                    <div className="subtitle">{intl.formatMessage({id: (fleet.assetCount === 1 ? 'fleet.attr.assetCountOne' : 'fleet.attr.assetCount')}).toUpperCase()}</div>
                </div>
            </div>
        )

        if (this.props.onClick == null) {
            return (
                <div className="scuf-chart">
                    {donut}
                </div>
            )
        }
        return (
            <div className="scuf-chart" onClick={() => this.props.onClick()}>
                {donut}
            </div>
        )
    }
}

export default injectIntl(FleetChart)
